import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Brand";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setWorkshop } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    // Parse session_id from URL fragment
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      toast.error("Sesión de Google inválida");
      navigate("/entrar", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setWorkshop(data);
        if (data?.is_new) {
          localStorage.setItem("prompt_workshop_name", "1");
        }
        toast.success(`Bienvenido, ${data.name}`);
        window.history.replaceState(null, "", "/");
        navigate("/panel", { replace: true });
      } catch (e) {
        toast.error(errMsg(e, "No se pudo iniciar sesión con Google"));
        navigate("/entrar", { replace: true });
      }
    })();
  }, [location.hash, navigate, setWorkshop]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center text-white space-y-3">
        <div className="animate-pulse">
          <Logo size={64} />
        </div>
        <p className="text-lg">Terminando de iniciar sesión...</p>
      </div>
    </div>
  );
}
